import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import '../styles/reset.scss'
import '../styles/style.scss'

const Layout = ({ children }) => (
  <div className="wrapper">
    <Header/>
    {children}
    <Footer/>
  </div>
)
export default Layout;